var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0384 3.78873C14.0446 3.92953 14.0446 4.06393 14.0446 4.20473C14.0508 8.47355 10.9144 13.4016 5.17895 13.4016C3.48731 13.4016 1.82655 12.896 0.400391 11.9488C0.647344 11.9808 0.894298 11.9936 1.14125 11.9936C2.54271 11.9936 3.90713 11.5072 5.01225 10.6048C3.6787 10.5792 2.50567 9.67675 2.0982 8.35835C2.56741 8.45435 3.04897 8.43515 3.50583 8.30075C2.05498 8.00635 1.0116 6.68154 1.00543 5.13914C1.00543 5.12634 1.00543 5.11354 1.00543 5.10074C1.4376 5.35034 1.92533 5.49114 2.41924 5.50394C1.05482 4.55673 0.628823 2.66873 1.45612 1.19032C3.0428 3.21273 5.37651 4.43513 7.88309 4.56953C7.62996 3.44953 7.9757 2.27193 8.78447 1.47832C10.0378 0.25592 12.0134 0.319921 13.1988 1.61912C13.8964 1.47832 14.5694 1.20952 15.1806 0.831922C14.946 1.58072 14.4582 2.21433 13.81 2.61753C14.4274 2.54073 15.0324 2.36793 15.6004 2.11193C15.1806 2.76473 14.6496 3.32793 14.0384 3.78873Z",
    fill: "#1D9BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.2b16332693983ecc51b4ce4c241e1f9b.svg";
export { ForwardRef as ReactComponent };